export enum StarPrinterScannerEventState {
  started = 'started',
  readerConnected = 'readerConnected',
  readerDisconnected = 'readerDisconnected',
  stopped = 'stopped'
}
